<template>
    <div>
    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;" class="title">Gates</span>
            </div>
 
            <el-table
                v-loading="loading" 
                element-loading-text="Loading..."
                :data="gates"
                highlight-current-row
                @current-change="handleCurrentChange"
                :height="tableHeight"
                stripe
                style="width: 100%">
            <el-table-column
              label="Name"
              prop="FullName_EN"
              align="left"
              sortable
            >
              <template slot-scope="scope">
                <img :src="getAsset(scope.row.ImagePath, 'student')" alt="" class="img-circle" style="width: 50px; float: left;">
                {{scope.row.FullName_EN}}  <br/>   {{scope.row.FullName_AR}}

          </template>
                  </el-table-column>

            <el-table-column
              label="Gate Name"
              prop="Name_EN"
              align="left"
              sortable
            >
               <template slot-scope="scope">
 
                {{scope.row.Name_EN}}  <br/>   {{scope.row.Name_AR}}

          </template>
            </el-table-column>

                 <el-table-column
              label="First Reader Time"
              prop="FirstReaderTime"
              align="left"
              sortable
            >
             </el-table-column>

                              <el-table-column
              label="Last Reader Time"
              prop="LastReaderTime"
              align="left"
              sortable
            >
             </el-table-column>
            </el-table>
            <div style="padding:10px" ref="pagination">
               <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 30, 50, 70, 100]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next"
              :total="total"
              >
            </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
  
  export default {

    data () {
      return {
        searchText: '',
        loading: false,
        gates: [],
        filteredGates: [],
        currentPage: 1,
        visitedPage: [1],
        currentRow: null,
        tableHeight: 0,
        new_page: false,
        limit: 20,
        total: 0
      }
    },
    mounted () {
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.pagination.offsetHeight + 53)
      this.getGates()
    },
    computed: {
    },
    methods: {
      getGates () {
        let self = this
        this.loading = true
        this.$http.get('/gate?limit=' + this.limit + '&offset=' + this.limit * (this.currentPage - 1)).then(function (response) {
          self.gates = response.data.activity
          self.total = response.data.total
          console.log(response.data.total)
          self.new_page = self.loading = false
        }).catch(function (response) {})
      },
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getGates()
      },
      handleSizeChange (val) {
        this.limit = val
        this.gates = []
        this.visitedPage = [1]
        this.getGates()
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Gate.vue?482d84aa